import { Component, inject } from "@angular/core";
import { PageComponent, PagedArray } from "@tytapp/common";
import { UserService } from "@tytapp/user";
import { ActivatedRoute } from "@angular/router";
import { ApiPoll, ApiUser, PollsApi } from "@tytapp/api";

@Component({
    templateUrl: './poll-list.component.html',
    styleUrls: ['./poll-list.component.scss']
})
export class PollListComponent extends PageComponent {
    private userService = inject(UserService);
    private pollsApi = inject(PollsApi);

    user: ApiUser;
    polls: PagedArray<ApiPoll>;
    statuses = ['all', 'published', 'closed', 'draft'];
    status = 'all';

    page: number = 1;
    pageSize: number = 20;
    total: number;

    get showStatusFilters() {
        if (!this.user)
            return false;

        return this.user.staff;
    }

    get hasDrafts() {
        if (!this.polls)
            return false;

        return this.polls.some(x => x.status === 'draft');
    }

    get draftPolls() {
        if (!this.polls)
            return undefined;
        return this.polls.filter(x => x.status === 'draft');
    }

    get publishedPolls() {
        if (!this.polls)
            return undefined;
        return this.polls.filter(x => x.status !== 'draft');
    }

    humanizeStatus(status) {

        let map: any = {
            published: 'Published',
            draft: 'Drafts',
            closed: 'Closed',
            all: 'All'
        };

        if (!this.isStaff) {
            map = {
                published: 'Open',
                closed: 'Closed',
                all: 'All'
            };
        }

        return map[status] || status;
    }

    get isStaff() {
        if (!this.user)
            return false;

        return this.user.staff;
    }

    humanizeType(type) {
        let map = {
            ChooseOnePoll: 'Choose One'
        };

        return map[type] || type;
    }

    humanizeStatusSingular(status) {
        let map = {
            published: 'Published',
            draft: 'Draft',
            closed: 'Closed',
            all: 'All'
        };

        return map[status] || status;
    }

    init() {
        this.subscribe(this.userService.userChanged, user => {
            this.user = user;
            if (this.isStaff) {
                this.statuses = ['published', 'closed', 'draft', 'all'];
            } else {
                this.statuses = ['published', 'closed', 'all'];
            }
        });

        this.route.queryParamMap.subscribe(map => {
            this.status = map.get('status') || 'all';
            this.page = Number(map.get('page')) || 1;
            this.fetchPolls();
        });
    }

    switchStatus(status: string) {
        this.page = 1;
        this.router.navigate([], {
            queryParams: {
                status,
                page: this.page
            }
        });
    }

    async fetchPolls() {
        this.polls = null;
        this.polls = await this.pollsApi.all(this.status, 'ChooseOnePoll', undefined, this.page).toPromise();
        this.total = this.polls.total;
    }

    goToPage(page) {
        this.page = page;

        this.router.navigate([], {
            queryParams: {
                status: this.status,
                page: this.page
            }
        });
    }

    async deletePoll(id: string) {
        if (confirm('Are you sure you want to delete the poll?')) {
            this.polls = null;
            await this.pollsApi.triggerPollEvent(id, 'archive').toPromise();
            this.fetchPolls();
        }
    }
}